import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";

const AdminMenu = () => {
  return (
    <div
      className="container-fluid p-0"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Header title="管理者メニュー" />

      <div className="container mt-5" style={{ maxWidth: "800px" }}>
        <p className="text-muted mb-4">管理項目を選択してください。</p>

        <div className="row g-4">
          {/* カテゴリ管理 */}
          <div className="col-md-6">
            <Link to="/categories" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-warning bg-opacity-10 text-warning rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: Tags */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z" />
                      <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z" />
                      <path d="M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">カテゴリ管理</h5>
                  <p className="card-text text-muted small">
                    「新規開発」「保守」などのカテゴリを管理します
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* プロジェクト管理 */}
          <div className="col-md-6">
            <Link to="/projects" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-success bg-opacity-10 text-success rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: List Task */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"
                      />
                      <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9a.5.5 0 0 0 0 0z" />
                      <path
                        fillRule="evenodd"
                        d="M2 6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5H2zM3 7H2v1h1V7z"
                      />
                      <path d="M5.5 10.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z" />
                      <path
                        fillRule="evenodd"
                        d="M2 10.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zM3 11H2v1h1v-1z"
                      />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">
                    プロジェクト管理
                  </h5>
                  <p className="card-text text-muted small">
                    プロジェクトの追加・無効化を行います
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* ユーザー管理 */}
          <div className="col-md-6">
            <Link to="/users" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: People */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.176.593.69.758 1.457.76 1.72-.003.052-.029.12-.063.194H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">ユーザー管理</h5>
                  <p className="card-text text-muted small">
                    ユーザーの編集・権限設定を行います
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* 締め日管理 */}
          <div className="col-md-6">
            <Link to="/admin/closing" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: Calendar Check */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">締め日管理</h5>
                  <p className="card-text text-muted small">
                    業務報告締め日を設定・管理します
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <p className="text-muted mb-4 mt-5">出力項目を選択してください。</p>

        <div className="row g-4 mb-5">
          {/* 業務報告出力 */}
          <div className="col-md-6">
            <Link to="/admin/export" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-info bg-opacity-10 text-info rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: Download */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">業務報告出力</h5>
                  <p className="card-text text-muted small">
                    期間を指定して全ユーザーの業務報告をCSV出力します
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* 監査ログ出力 */}
          <div className="col-md-6">
            <Link to="/admin/audit_export" className="text-decoration-none">
              <div className="card h-100 shadow-sm border-0 admin-menu-hover-effect">
                <div className="card-body p-4 text-center">
                  <div className="bg-info bg-opacity-10 text-info rounded-circle d-inline-flex p-3 mb-3">
                    {/* Bootstrap Icons: Journal Check */}
                    <svg
                      width="32"
                      height="32"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                      />
                      <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                      <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                    </svg>
                  </div>
                  <h5 className="card-title fw-bold text-dark">監査ログ出力</h5>
                  <p className="card-text text-muted small">
                    期間を指定して監査ログをCSV出力します
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AdminMenu;
